// // import React from 'react'

// // const MobileCard = () => {
// //   return (
// //     <div>MobileCard</div>
// //   )
// // }

// // export default MobileCard
// import React from "react";
// import {
//   Card,
//   CardMedia,
//   CardContent,
//   CardActions,
//   Typography,
//   IconButton,
//   Button,
//   Box,
// } from "@mui/material";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

// const MobileCard = () => {
//   return (
//     <Card sx={{ maxWidth: 180, borderRadius: "0px"  }}>
//       {/* Top Image */}
//       <CardMedia
//         component="img"
//         height="120"
//         image="https://via.placeholder.com/345x180"
//         alt="Card Image"
//         sx={{border: "1px solid red"}}
//       />

//       {/* Title with Icon */}
//       <CardContent
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Typography variant="h6" component="div">
//           Card Title
//         </Typography>
//         <IconButton aria-label="add to favorites">
//           <FavoriteBorderIcon />
//         </IconButton>
//       </CardContent>

//       {/* Description */}
//       <CardContent>
//         <Typography variant="body2" color="text.secondary">
//           This is a brief description of the card content. It provides
//           additional information.
//         </Typography>
//       </CardContent>

//       {/* Action Button */}
//       <CardActions>
//         <Button size="small" variant="contained" color="primary">
//           Learn More
//         </Button>
//       </CardActions>
//     </Card>
//   );
// };

// export default MobileCard;
import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useNavigate } from "react-router-dom";

const MobileCard = ({
  card_img,
  card_title,
  card_title2,
  card_description,
  index,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // navigate("/solution1");
    navigate("/products", { state: { index: index } });
  };
  return (
    <Card
      sx={{
        width: "70vw",
        // height: "380px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: 2,
        marginBottom: 2,
        paddingTop: 2,
      }}
    >
      {/* Top Image */}
      {/* <CardMedia
        component="img"
        height="120"
        image={card_img}
        alt={card_title}
      /> */}

      <CardMedia
        component="img"
        // height="120"
        image={card_img}
        alt={card_title}
        sx={{
          objectFit: "contain",
          width: 120,
          height: 120,
          borderRadius: '50%',
        }}
      />

      {/* Title with Icon */}
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          //   justifyContent: "space-between",
          //   alignItems: "center",
          paddingBottom: 0,
        }}
      >
        <Typography sx={{ textAlign: "center", fontWeight: 600 }}>{card_title}</Typography>
        <Typography sx={{ textAlign: "center" }}>{card_title2}</Typography>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteBorderIcon />
        </IconButton> */}
      </CardContent>

      {/* Description */}
      <CardContent sx={{ paddingTop: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {card_description}
        </Typography>
      </CardContent>

      {/* Action Button */}
      {/* <CardActions sx={{ paddingBottom: 3 }}>
        <Button
          size="small"
          variant="contained"
          onClick={handleClick}
          sx={{
            backgroundColor: "rgb(5, 78, 146)",
            color: "white",
            borderColor: "rgb(5, 78, 146)",

            "&:hover": {
              backgroundColor: "rgb(31, 133, 192)", // Hover background
              borderColor: "rgb(31, 133, 192)", // Hover border
            },
          }}
        >
          Know More
        </Button>
      </CardActions> */}
    </Card>
  );
};

export default MobileCard;
